export function filterAndSortPlatos(platos, q) {
    const term = String(q || "").trim().toLowerCase();

    return (Array.isArray(platos) ? platos : [])
        .filter((p) => {
            if (!term) return true;
            const campos = [p?.nombre, p?.descripcion]
                .filter(Boolean)
                .map((v) => String(v).toLowerCase());

            const alergTxt = (p?.alergenos || []).map((a) =>
                String(a?.alergenoDescripcion || a?.alergeno || "").toLowerCase()
            );

            return [...campos, ...alergTxt].some((txt) => txt.includes(term));
        })
        .sort((a, b) => String(a?.nombre || "").localeCompare(String(b?.nombre || ""), "es"));
}
